export default [
    {
        title: 'Category A',
        name: 'Too Much Estrogen',
        url: 'https://www.anaisgautron.com/estrogen-dominant',
        score: [],
        checkboxes: [
            'I experience bloating or I feel puffy',
            'I feel irritable, I have mood swings',
            'I have heavy, painful periods',
            'I have gained weight or have difficulty losing weight, especially around my hips and thighs',
            'I have fibroids',
            'I sometimes cry over nothing',
            'I get headaches or migraines',
            'I experience brain fog',
            'I have gallbladder problems or had my gallbladder removed',
        ],
        factor: 1,
        family: 'Estrogen',
    },
    {
        title: 'Category B',
        name: 'Too Little Estrogen',
        url: 'https://www.anaisgautron.com/low-estrogen',
        score: [],
        checkboxes: [
            'I’m emotionally fragile',
            'My memory is not as good as it used to',
            'My periods are shorter than three days',
            'I struggle with depression, anxiety, or lethargy',
            'I have night sweats and/or hot flashes',
            'I’ve had trouble with recurrent bladder infections',
            'I sometimes have problems with urinary leakage',
            'I have difficulty sleeping, I wake up at night',
            'My breasts are smaller and/or I feel they are drooping',
            'I have achy joints or am prone to joint injuries',
            'My brown spots are more noticeable',
            'I am noticing more fine lines and wrinkles',
            'I have dry or thinning skin',
            'I have a low libido',
            'I have vaginal dryness or pain when having sex',
        ],
        factor: -1,
        family: 'Estrogen',
    },
    {
        title: 'Category C',
        name: 'Too Little Progesterone',
        url: 'https://www.anaisgautron.com/low-progesterone',
        score: [],
        checkboxes: [
            'I experience PMS seven to ten days before my period',
            'I get headaches or migraines around my period',
            'I feel anxious often',
            'I have painful, heavy periods',
            'My breasts are painful or swollen before my period',
            'I feel agitated, irritable before my period',
            'I have had a miscarriage in the first trimester',
            'I experience restless legs, especially at night',
            'I have had difficulty getting pregnant (after trying for six or more months)',
        ],
        factor: -1,
        family: 'Progesterone',
    },
    {
        title: 'Category D',
        name: 'Too Much Testosterone',
        url: 'https://www.anaisgautron.com/high-testosterone',
        score: [],
        checkboxes: [
            'I have abnormal hair growth on my face, chest, and/or abdomen',
            'I have acne',
            'I have oily skin and/or hair',
            'I have areas of darker skin (eg, armpits)',
            'I’ve noticed thinning hair on my head',
            'I have skin tags',
            'I struggle with depression and/or anxiety',
            'I have PCOS',
            'I have had difficulty getting pregnant (after trying for six or more months)',
        ],
        factor: 1,
        family: 'Testosterone',
    },
    {
        title: 'Category E',
        name: 'Too Little Testosterone',
        url: 'https://www.anaisgautron.com/low-testosterone',
        score: [],
        checkboxes: [
            'I have a low libido',
            'I struggle with depression, have mood swings, or cry easily',
            'I have no motivation',
            'I am tired or fatigued throughout the day or have been diagnosed with chronic fatigue syndrome',
            'I’m unable to gain muscle, and I’m losing muscle mass',
            'I have a decrease in bone density or have been diagnosed with osteopenia or osteoporosis',
            'I have urinary incontinence',
            'I have a loss of sexual fantasies',
            'I have difficulty or am unable to orgasm',
            'I have cardiovascular symptoms or heart disease',
            'I’ve had weight gain',
            'I have anxiety or panic attacks',
        ],
        factor: -1,
        family: 'Testosterone',
    },
    {
        title: 'Category F',
        name: 'Too Little Cortisol',
        url: 'https://www.anaisgautron.com/low-cortisol',
        score: [],
        checkboxes: [
            'I feel tired in the morning, even after a full night’s sleep',
            'I depend on caffeine to get through my day',
            'I want to take naps most days',
            'My energy crashes in the afternoon',
            'I crave salty or sweet food',
            'I’m dizzy when I stand up too quickly',
            'I feel constant stress',
            'I have difficulty falling asleep and/or staying asleep',
            'My muscles feel weaker',
            'I get sick often and/or have a difficult time recovering',
            'I have low blood sugar issues',
        ],
        factor: -1,
        family: 'Cortisol',
    },
    {
        title: 'Category G',
        name: 'Too Much Cortisol',
        url: 'https://www.anaisgautron.com/high-cortisol',
        score: [],
        checkboxes: [
            'My life is crazy stressful',
            'I feel overwhelmed by stress',
            'I have extra weight around my midsection',
            'I have difficulty falling or staying asleep',
            'My body is tired at night, but my mind is racing',
            'I get a second wind at night that keeps me from falling asleep',
            'I wake between 2 and 4 am and can’t go back to sleep',
            'I feel easily distracted',
            'I get angry quickly',
            'I have high blood pressure or a fast heart rate',
            'I have elevated blood sugar or diabetes',
            'I get shaky if I don’t eat often',
            'I’m prone to injury and have difficulty healing',
        ],
        factor: 1,
        family: 'Cortisol',
    },
    {
        title: 'Category H',
        name: 'Too Little Thyroid Hormone',
        url: 'https://www.anaisgautron.com/low-thyroid-hormones',
        score: [],
        checkboxes: [
            '\tI have brain fog or feel like my memory isn’t what it used to be',
            'I’m losing hair (scalp, body, outer third of the eyebrows)',
            'My hair is dry and tangles easily',
            'I’m constipated often and need a stimulant (like caffeine) to get a bowel movement',
            'I’m cold and/or have cold hands and feet',
            'My periods are sporadic or occur more than thirty-five days apart',
            'I have joint or muscle pain',
            'I have dry skin',
            'I have had difficulty getting pregnant (after trying for six or more months) or have had a first trimester miscarriage',
            'I am in a low mood or struggle with depression',
            'I’m tired no matter how much I sleep',
            'I find it difficult to sweat',
            'I have recurrent headaches',
            'I have high cholesterol',
            'I have a hoarse voice most days',
        ],
        factor: -1,
        family: 'Thyroid hormone',
    },
];
